import axios from "axios";
import { getToken } from "../lib/auth";

const axiosNewApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Add auth interceptor
axiosNewApi.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

axiosNewApi.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response;
    } else {
      return Promise.reject(new Error("not found"));
    }
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.log("Request canceled", error.message);
      return Promise.resolve(null);
    }

    return Promise.reject(error);
  }
);

export default axiosNewApi;
